// extracted by mini-css-extract-plugin
export default {"avatar":"index_avatar_iNsCV","large":"index_large_D6zea","normal":"index_normal_BcqIJ","small":"index_small_MWKWS","unset":"index_unset_DL9q0","circle":"index_circle_n1YUi"};